import React from "react";
import Section from "./Section";
import Footer from "./Footer";
import Navbar from "../../layout/Navbar";

const Index5 = () => {
  return (
    <React.Fragment>
      <Navbar />
      <Section />
      <Footer />
    </React.Fragment>
  );
};

export default Index5;
